import type { PermissionExpr } from './check'

/**
 * Literais das permissions de auditoria (`app/permissions/permissions.py::AuditPermissions`).
 * Const porque o contract test (`literals.test.ts`) só alcança CONSTS e `check.ts` faz `includes()` exato:
 * literal errado é fail-closed e mudo.
 */
export const AUDIT_PERMISSIONS = {
  /** `/audit/sessions|logs|auth-events` e os resumos; `/audit/team/*` pede `TEAM_READ`. O literal solto de `check.ts` (`ADMIN_ACCESS`) segue lá. */
  READ: 'audit:read',
  /**
   * IP, rede e geo de OUTRA pessoa em toda leitura de auditoria (`/audit/logs`, `/audit/auth-events` e o resumo):
   * sem ela o back corta (`audit/visibility.py::ve_rede_de`) e o `?ip=` de `/audit/auth-events` dá 403. O próprio
   * registro sai sempre. **`READ` NÃO implica** — no preset `owner` (`sub_roles/defaults.py:149`); tenant existente
   * só recebe por `reseed_subrole_presets` do back.
   */
  NETWORK_READ: 'audit:network:read',
  /**
   * As abas Equipe e Rede de `/admin/audit` (faixa 41: `GET /audit/team/*`, que exigem ela; `/networks` também
   * `NETWORK_READ`). FORA de todo preset: o dstorres concede em runtime. **Não implica `READ`** — quem só a tem
   * entra no console só com as abas Equipe e Rede.
   */
  TEAM_READ: 'audit:team:read',
} as const

/**
 * Entrada do console `/admin/audit` (rota, nav e hub): QUALQUER uma das duas abre (D32 do bloco 8, D36 do bloco 9).
 * O que cada uma mostra é o recorte do mapa na página (`admin/audit/_lib/abasDaAuditoria::abasVisiveis`): `READ` →
 * Presença, Atividade, Erros e Acessos; `TEAM_READ` → Equipe e Rede (Dispositivos; Mapa e Redes só junto de
 * `NETWORK_READ`).
 */
export const AUDIT_ACCESS: PermissionExpr = { or: [AUDIT_PERMISSIONS.READ, AUDIT_PERMISSIONS.TEAM_READ] }
